// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__IZZem","inputWrap":"styles_inputWrap__3bkmt","input":"styles_input__3qMGg"};